import { knn } from '../../reducers/knn';
import { homes } from '../../reducers/homes';
import { sector } from '../../reducers/sector';
import { paths } from '../../reducers/paths';
import { lines } from '../../reducers/lines';
import { cities } from '../../reducers/cities';
import { estratos } from '../../reducers/estratos';
import { locations } from '../../reducers/locations';
import { layers } from '../../reducers/layers'
export const models = {
    cities,
    sector,
    homes,
    estratos,
    locations,
    paths,
    knn,
    lines,
    layers
};
